import React, {useEffect, useState} from 'react';
import Quiz from "./Quiz";
import {CheckAnswer} from "./CheckAnswer";
import {CreateAssignmentOptions} from "../../helpers/CreateAssignmentOptions";
import firebase from "firebase";
import axios from 'axios'
import {UserVisitedPage} from "../../helpers/UserVisitedPage";
import {CreateQuizEntry} from "../../helpers/QuizData/CreateQuizEntry";
import {UpdateQuizData} from "../../helpers/QuizData/UpdateQuizData";
import {CheckCompletion} from "../../helpers/QuizData/CheckCompletion";
import {FetchQuizData} from "../../helpers/QuizData/FetchQuizData";
import {CreateAssignmentOptionCompletion} from "../../helpers/QuizData/CreateAssignmentOptionCompletion";
import {UpdateCompletionDate} from "../../helpers/QuizData/UpdateCompletionDate";


function QuizWrapper(
    {
        classLevel
    }
) {

    //All the UI for assignment questions
    const [question, setQuestion] = useState(null);
    const [answer, setAnswer] = useState("");
    //attempts are for each question
    const [attempts, setAttempts] = useState(0);
    const [currentQuestionNum, setCurrentQuestionNum] = useState(1);
    const [assignmentNum, setAssignmentNum] = useState(null)
    const [assignmentLength, setAssignmentLength] = useState(0);
    //This is the object CheckAnswer returns
    const [result, setResult] = useState({
        report: '',
        closestAnswer: '',
        numberOfWordsInAnswer: 0
    });
    const [showHint, setShowHint] = useState(false);
    const [gradeColor, setGradeColor] = useState(null);
    const [imageURL, setImageURL] = useState('');
    const [sound, setSound] = useState(new Audio());
    const [imageURLS, setImageURLS] = useState([]);
    const [soundsURLS, setSoundsURLS] = useState([]);
    const [tmpCheckMark, setTmpCheckMark] = useState(false);

    const [assignmentOptions, setAssignmentOptions] = useState([]);
    const [assignmentChosen, setAssignmentChosen] = useState(false);
    const [assignmentNames] = useState([]);
    const [currentAssignment, setCurrentAssignment] = useState([]);

    //Used for collection student data
    const [assignmentCompletion, setAssignmentCompletion] = useState([]);
    const [currentAssignmentCompletion, setCurrentAssignmentCompletion] = useState([]);

    //Loading Messages
    const [loadingMessage, setLoadingMessage] = useState('');
    const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');

    useEffect(() => {
        UserVisitedPage();
        setLoading(true);

        //If user is logged in, check to see if they have a quiz entry,
        //If not, create quiz entry for every existing assignment
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                setUserIsLoggedIn(true);
                setLoadingMessage('If this is your first time, this may take a while...' )
                CreateQuizEntry(classLevel).then((res) => {
                    FetchQuizData(classLevel).then((data) => {
                        setAssignmentCompletion(data)
                        setAssignmentOptions(CreateAssignmentOptionCompletion(data))
                    }).then(() => {
                            setLoadingMessage('');
                            setLoading(false)
                        }
                    )
                })
            }
        });

        //Fetch assignment
        async function fetchData() {
            await firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/quizAssignments').listAll()
                .then((data) => {
                    for (let i = 0; i < data.items.length; i++) {
                        assignmentNames.push("assignment" + (i + 1) + ".json")
                    }
                    firebase.auth().onAuthStateChanged((user) => {
                        if(!user){
                            setAssignmentOptions(CreateAssignmentOptions(data.items))

                        }
                    })

                }).catch(e => console.log(e));
        }
        fetchData().then(r => setLoading(false)).catch(e => console.log('Could not fetch data'));
    }, []);

    //Updates green check mark for every question
    useEffect(() => {
        setTmpCheckMark(false);
        setCurrentAssignmentCompletion(assignmentCompletion[assignmentNum])
    }, [assignmentNum, currentAssignment, currentQuestionNum, question, assignmentCompletion])

    const handleAnswerChange = (event) => {
        setAnswer(event.target.value);
    };
    const handleSubmit = () => {
        setAttempts((prevState => prevState + 1));
        //returns an object with properties of result, closestAnswer, and numberOfWordsInAnswer
        // setResult(CheckAnswer(g_questionDatabase[assignmentNum][currentQuestionNum - 1], answer));
        let tmpResult = CheckAnswer(currentAssignment[currentQuestionNum - 1], answer);
        setResult(tmpResult);
        if (tmpResult.report === "🤙🏽🤙🏽🤙🏽Perfect!🤙🏽🤙🏽🤙🏽") {
            //temporary check mark for immediate feedback.
            //Asynchronous call to server takes time to update
            setTmpCheckMark(true);

            //Updates stars
            if(userIsLoggedIn){
                setAssignmentOptions(CreateAssignmentOptionCompletion(assignmentCompletion))
            }

            //Update student file
            UpdateQuizData(assignmentNum, (currentQuestionNum - 1), classLevel, attempts, showHint).then(() => {
                //Updates check marks
                CheckCompletion(classLevel, assignmentNum).then((res) => {
                    setAssignmentCompletion(res);
                    //If entire assignment is completed, log the date
                    UpdateCompletionDate(assignmentNum, classLevel, res[assignmentNum])
                })
            });
            setGradeColor("green")
        } else {
            setGradeColor("red")
        }
    };

    const handleAssignmentChange = async (e, {value}) => {
        setAssignmentNum(value);
        setCurrentQuestionNum(1);
        setProgress(0);

        async function fetchData() {
            setLoading(true);
            setAssignmentChosen(false);
            let tmpAssignment = [];

            //fetches new assignmentm based on assignmentNum i.e., "value"
            const assignment = firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/quizAssignments/' + assignmentNames[value]);
            await assignment.getDownloadURL()
                .then(url => axios.get(url))
                .then(res => {
                    tmpAssignment = res.data;
                    setAssignmentLength(res.data.length);
                    setQuestion(res.data[0].question);

                    //To update green check marks
                    CheckCompletion(classLevel, res).then((res) => setAssignmentCompletion(res))
                });
            let retrievedImagesUrlArray = [];
            let retrievedSoundsURLArray = [];
            for (let i = 0; i < tmpAssignment.length; i++) {

                //Checks to see if assignment has a picture
                //If not, hold empty string and UI checks if empty, then display no picture
                if (tmpAssignment[i].picture === "") {
                    retrievedImagesUrlArray.push("")
                } else {

                    //If has picture, get the URL
                    const assignmentImage = firebase.storage().ref().child('pictures/' + tmpAssignment[i].picture);
                    await assignmentImage.getDownloadURL()
                        .then(url => {
                            retrievedImagesUrlArray.push(url);
                            setProgress(prevState => prevState + Math.round(50 / Math.round(tmpAssignment.length)));
                            setProgressText('Loading pictures');
                        })
                }

                //Same for audio, see comment above for picture
                if (tmpAssignment[i].audio === "") {
                    retrievedSoundsURLArray.push("");
                } else {
                    const retrievedSound = firebase.storage().ref().child('sounds/' + tmpAssignment[i].audio);
                    await retrievedSound.getDownloadURL().then((url) => {
                        retrievedSoundsURLArray.push(url)
                        setProgress(prevState => prevState + Math.round(50 / Math.round(tmpAssignment.length)));
                        setProgressText('Loading sounds');
                    })
                }
            }
            setImageURLS(retrievedImagesUrlArray);
            setImageURL(retrievedImagesUrlArray[0]);
            setSoundsURLS(retrievedSoundsURLArray);
            setSound(new Audio(retrievedSoundsURLArray[0]));
            setAssignmentLength(tmpAssignment.length)
            setQuestion(tmpAssignment[0].question);
            setCurrentAssignment(tmpAssignment);


        }

        await fetchData()
            .then(() => {
                setLoading(false);
                setAssignmentChosen(true);
            })
        clearResults()
    };

    //hange question, question number, picture, and audio
    const incrementQuestion = () => {
        if (currentQuestionNum < currentAssignment.length) {
            setCurrentQuestionNum(prevState => prevState + 1);
            let tmpCurrentQuestionNum = currentQuestionNum;
            setImageURL(imageURLS[tmpCurrentQuestionNum])
            setSound(new Audio(soundsURLS[tmpCurrentQuestionNum]))
            setQuestion(currentAssignment[tmpCurrentQuestionNum].question)
        }
        clearResults()
    };
    const decrementQuestion = () => {
        if (currentQuestionNum > 1) {
            setCurrentQuestionNum(prevState => prevState - 1);
            let tmpCurrentQuestionNum = currentQuestionNum;
            setImageURL(imageURLS[tmpCurrentQuestionNum - 2]);
            setSound(new Audio(soundsURLS[tmpCurrentQuestionNum - 2]));
            setQuestion(currentAssignment[tmpCurrentQuestionNum - 2].question)
        }
        clearResults()
    };

    //easy helper function to reset fields and stored state
    const clearResults = () => {
        setShowHint(false);
        setAttempts(0);
        setAnswer("");
        setResult({
            report: '',
            closestAnswer: '',
            numberOfWordsInAnswer: 0
        });
    };

    //used for dictionary
    const handleRedirect = () => {
        window.open('http://www2.hawaii.edu/%7Eleighj/SAMOAN/dictionary/')
    };

    const toggleHint = () => {
        setShowHint(true);
        sound.play().catch(e => console.log(e))

    };

    return (
        <>

            <Quiz
                handleRedirect={handleRedirect}
                question={question}
                gradeColor={gradeColor}
                answer={answer}
                result={result}
                showHint={showHint}
                toggleHint={toggleHint}
                attempts={attempts}
                handleAnswerChange={handleAnswerChange}
                handleSubmit={handleSubmit}
                setAssignmentNum={setAssignmentNum}
                assignmentNum={assignmentNum}
                currentQuestionNum={currentQuestionNum}
                assignmentLength={assignmentLength}
                incrementQuestion={incrementQuestion}
                decrementQuestion={decrementQuestion}
                handleAssignmentChange={handleAssignmentChange}
                loading={loading}
                assignmentOptions={assignmentOptions}
                imageURL={imageURL}
                progress={progress}
                progressText={progressText}
                assignmentChosen={assignmentChosen}
                currentAssignmentCompletion={currentAssignmentCompletion}
                tmpCheckMark={tmpCheckMark}
                loadingMessage={loadingMessage}
                userIsLoggedIn={userIsLoggedIn}
            />
        </>
    )
}

export default QuizWrapper
